import { render, staticRenderFns } from "./auditFail.vue?vue&type=template&id=a3353d12&scoped=true&"
import script from "./auditFail.vue?vue&type=script&lang=js&"
export * from "./auditFail.vue?vue&type=script&lang=js&"
import style0 from "./auditFail.vue?vue&type=style&index=0&id=a3353d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3353d12",
  null
  
)

export default component.exports